import { render, staticRenderFns } from "./ZipForm.vue?vue&type=template&id=a19faae6&scoped=true&"
import script from "./ZipForm.vue?vue&type=script&lang=js&"
export * from "./ZipForm.vue?vue&type=script&lang=js&"
import style0 from "./ZipForm.vue?vue&type=style&index=0&id=a19faae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19faae6",
  null
  
)

export default component.exports